import React, { useEffect,useState } from "react";
import { Link } from "react-router-dom";
// import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
// import { useFormik, FormikProvider } from "formik";// import * as Yup from "yup";
 import CreatableSelect from "react-select/creatable";

import { useFormik, FormikProvider } from "formik";
import {  Apitoken, Authtoken  } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";

const AddProduct = () => {
  const [statusOptions, setStatusOptions] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  // const initialOptions = ['Option 1', 'Option 2', 'Option 3'];
  // const [options, setOptions] = useState(initialOptions);
  const [permission, setPermission] = useState({});

  const [productList, setProductList] = useState([]);
  

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      product_type: "",
      product_category:"",
    },
   onSubmit: (values) => {
      axios
        .post("/products/add", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          $("#form-submit").text("Add Product"); 
          delete backendErrors['error'];
         // actions.setSubmitting(false);

          if (response.data.code === 200) {
           // setBackendSuccess(response.data.message);
            toast.success(response.data.message);
           // actions.resetForm();
            setTimeout(() => {
              window.location.href = "/products";
            }, 1000);
          }  else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error)
        //  actions.setSubmitting(false);
        });
    },
  });



  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  useEffect(() => {
        setPermission(FindModuleById(5)); 
console.log(permission);

  
    axios.post("/products/listing-groupby",{},
      {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }
    )
    .then((response) => {
      if (response.data.code === 200) {
        let supplier_types = response.data.data.products;

        let supplier_typesList = supplier_types.map((ord, index) => ({
          label: ord.name,
          value: ord.name,
          key: `product-${index}`,
        }));
        setProductList(supplier_typesList);
      }
     
    })
    .catch((error) => {
      console.log(error);
    });


    axios
      .get("/helpers/products-type", {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let supplier_types = response.data.data.product_types;


          let supplier_typesList = supplier_types.map((ord, index) => ({
            label: ord.title,
            value: ord.title,
            key: `product-${index}`,
          }));


          setStatusOptions(supplier_typesList);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get("/helpers/product-categories", {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let categories = response.data.data.categories;
          let categoriesList = categories.map((cat, index) => ({
            label: cat.title,
            value: cat.title,
            key: `categories-${index}`,
          }));
          setCategoriesList(categoriesList);

        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  


  
  
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />  <ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Products</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/products">Products</Link>
                    </li>
                    <li className="breadcrumb-item active">Add Product</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  {permission && permission.add == 1 && (
                    <div className="card-body">
                      <h4 className="card-title">Product Information</h4>
                       <FormikProvider value={formik}>
                       <form action="#" onSubmit={formik.handleSubmit}>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Name</label>
                                  <CreatableSelect
                                      className="w-100"
                                      value={
                                        formik.values.name
                                          ? productList.find(option => option.value === formik.values.name) || 
                                            { label: formik.values.name, value: formik.values.name }
                                          : null
                                      }
                                      name="name"
                                      onChange={(selectedOption) => {
                                        handleSelectChange("name", selectedOption);
                                      }}
                                      onBlur={formik.handleBlur}
                                      options={productList}
                                      placeholder="Select Product name or create"
                                      isClearable
                                    />
                              <small>
                                {backendErrors.name && (
                                  <span className="form-error mt-1">
                                    {backendErrors.name}
                                  </span>
                                )}
                              </small>
                            </div>
                          
                          </div>
                          <div className="col-md-4">
                          
                            <div className="form-group status">
                              <label>Product Category</label>
                              <CreatableSelect
                                className="w-100"
                                value={
                                  formik.values.product_category
                                    ? categoriesList.find(option => option.value === formik.values.product_category) || 
                                      { label: formik.values.product_category, value: formik.values.product_category }
                                    : null
                                }
                                name="product_category"
                                onChange={(selectedOption) => {
                                  handleSelectChange("product_category", selectedOption);
                                }}
                                onBlur={formik.handleBlur}
                                options={categoriesList}
                                placeholder="Select Category create"
                                isClearable
                             />
                              <small>
                                {backendErrors.product_category && (
                                    <span className="form-error mt-1">
                                      {backendErrors.product_category}
                                    </span>
                                  )}
                              </small>
                            </div>
                          </div>
                          <div className="col-md-4">
                          <div className="form-group product_type status">
                              <label>Product Type</label>
                              <CreatableSelect
                               className="w-100"
                                value={
                                  formik.values.product_type
                                    ? statusOptions.find(option => option.value === formik.values.product_type) || 
                                      { label: formik.values.product_type, value: formik.values.product_type }
                                    : null
                                }
                                name="product_type"
                                onChange={(selectedOption) => {
                                  handleSelectChange("product_type", selectedOption);
                                }}
                                onBlur={formik.handleBlur}
                                options={statusOptions}
                                placeholder="Select Type or  create"
                                isClearable
                              />
                              <small>
                                {backendErrors.product_type && (
                                  <span className="form-error mt-1">
                                    {backendErrors.product_type}
                                  </span>
                                )}
                              </small>
                            </div>
                          </div>
                          <div className="col-md-12">
                          <div className="form-group">
                              <label>Description</label>
                              <textarea
                                
                                name="description"
                                value={formik.values.description}
                                className= "form-input form-control"
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }} 
                                 onBlur={formik.handleBlur}
                              ></textarea>
                              <small>
                                {backendErrors.description && (
                                  <span className="form-error mt-1">
                                    {backendErrors.description}
                                  </span>
                                )}
                              </small>
                            </div>
                          </div>
                        </div>
                          <small>
                                {backendErrors.status  && (
                                  <span className="form-error mt-1">
                                    {backendErrors.status}
                                  </span>
                                )}

                              
                            
                              </small>
                        <div className="text-end mt-4">
                          <button
                            type="submit" id="form-submit"
                            className="btn btn-primary"
                            //disabled={formik.isSubmitting}
                          >
                            Add Product
                          </button>
                        </div>
                      </form>
                       </FormikProvider>
                      
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddProduct;
